export function calculateInstallment(
  amount: number,
  monthlyInterest: number,
  tenour: number
) {
  monthlyInterest = monthlyInterest / 100;
  const installment = Math.round(
    (amount * monthlyInterest) / (1 - Math.pow(1 + monthlyInterest, -tenour))
  );

  const totalReturn = installment * tenour;
  return {
    installment,
    totalReturn,
  };
}

export function calculateInstallmentBusiness(
  amount: number,
  monthlyInterest: number,
  tenour: number
) {
  monthlyInterest = monthlyInterest / 100;
  const interest = Math.round(amount *( monthlyInterest/12));
  const debt = Math.round(amount/tenour);

  console.log(interest, debt)
  const installment = interest + debt;
  // const installment = Math.round(
  //   (amount * monthlyInterest) / (1 - Math.pow(1 + monthlyInterest, -tenour))
  // );

  const totalReturn = installment * tenour;
  return {
    installment,
    totalReturn,
  };
}

export function compareSort(a: any, b: any, sortType: string) {
  if (a === null) a = 0;
  if (b === null) b = 0;
  if (a < b) {
    if (
      sortType.toLowerCase() === "desc" ||
      sortType.toLowerCase() === "descending"
    ) {
      return 1;
    }
    return -1;
  }
  if (a > b) {
    if (
      sortType.toLowerCase() === "desc" ||
      sortType.toLowerCase() === "descending"
    ) {
      return -1;
    }
    return 1;
  }
  return 0;
}

export function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export function downloadToFile(
  content: string,
  filename: string,
  contentType: string,
) {
  const a = document.createElement("a");
  const file = new Blob([content], { type: contentType });

  a.href = URL.createObjectURL(file);
  a.download = filename;
  a.click();

  URL.revokeObjectURL(a.href);
}

export async function imageUrlToBase64(url: string) {
  const data = await fetch(url);
  const blob = await data.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;

      resolve({
        base64: base64data,
        type: blob.type,
      });
    };
    reader.onerror = reject;
  });
}
